const storagePrefix = 'techem_direct_';

export enum StorageKey {
  ABTesting = 'ab_testing_'
}

// @deprecated Use the repository pattern instead.
const storage = {
  setABTestingValue: (forKey: string, value: string) => {
    window.localStorage.setItem(
      `${storagePrefix}${StorageKey.ABTesting}${forKey}`,
      JSON.stringify(value)
    );
  },

  getABTestingValue: (forKey: string) => {
    return JSON.parse(
      window.localStorage.getItem(`${storagePrefix}${StorageKey.ABTesting}${forKey}`) as string
    );
  }
};

export default storage;
